const useNotificationTapResponse = (): null => {
  return null;
};

export { useNotificationTapResponse };
